import { URLS } from '../../../constants';
import apiClient from '../../client';

const getScheduleEventAPI = {
  getScheduleEvent: ({
    providerId,
    groupId,
    childId,
    appointmentStartDate,
    appointmentEndDate,
    appointmentWith,
  }: {
    groupId: any;
    providerId: any;
    childId: any;
    appointmentStartDate: any;
    appointmentEndDate: any;
    appointmentWith?: { id: any; type: string } | null;
  }) =>
    apiClient.post(URLS.getScheduleEvent, {
      data: {
        providerId,
        groupId,
        childId,
        appointmentStartDate,
        appointmentEndDate,
        ...(appointmentWith ? { appointmentWith } : {}),
      },
    }),
};
export default getScheduleEventAPI;
